export const CLOSED = 'closed';
export const PAID = 'paid';
export const UNPAID = 'unpaid';
export const PENDING = 'pending';
export const ALL = 'all';
export const OPEN = 'open';
export const DATE_MONTH_YEAR = 'DD MMM YYYY';
export const YYYY_MM_DD = 'YYYY-MM-DD';
export const MONTH_YEAR = 'MMMM YYYY';
export const YEAR_MONTH = 'YYYY-MM';
export const MON_YEAR = 'MMM YYYY';
export const DATE_TIME = 'DD MMM YYYY, HH:mm';
export const STEPS = {
	MY_BILLS: 0,
	PAYMENT_METHOD: 1,
	CONFIRMATION: 2,
};

export const BILLING_TYPE = 'POSTPAID';
export const PAYMENT_TYPE = 'BILL';
export const DEFAULT_QUANTITY = '1';

export const BILLS_LIST = 'bills_list';
export const PAY_ANY_BILL = 'pay_any_bill';

export const EVENTS_SUCCESS: Record<string, string> = {
	[BILLS_LIST]: 'payment_initiated_success',
	[PAY_ANY_BILL]: 'bill_payment_success',
};

export const EVENTS_FAILURE: Record<string, string> = {
	[BILLS_LIST]: 'payment_initiated_failure',
	[PAY_ANY_BILL]: 'bill_payment_failure',
};
export const PAYMENT_METHOD = 'Payment Method';

export const PAYMENT_METHODS = {
	BANK_MUSCAT: 'Bank Muscat',
	CARD: 'Credit-Debit Card',
};

export const PAYER_AUTHENTICATION_REQUIRED = 'PAYER_AUTHENTICATION_REQUIRED';
export const CREDIT_CARD_PAYMENT_REQUEST_EXCEEDS_MAX_DONATION_AMOUNT =
	'CREDIT_CARD_PAYMENT_REQUEST_EXCEEDS_MAX_DONATION_AMOUNT';
export const DEBIT_CARD_PAYMENT_REQUEST_EXCEEDS_MAX_TOPUP_AMOUNT =
	'DEBIT_CARD_PAYMENT_REQUEST_EXCEEDS_MAX_TOPUP_AMOUNT';
export const TRANSACTION_REJECTED = 'TRANSACTION_REJECTED';

export const ERROR_MESSAGES_GA = {
	[PAYER_AUTHENTICATION_REQUIRED]: 'Payer Authentication Required',
	[CREDIT_CARD_PAYMENT_REQUEST_EXCEEDS_MAX_DONATION_AMOUNT]:
		'Credit Card Payment Request Exceeds Max Donation Amount',
	[DEBIT_CARD_PAYMENT_REQUEST_EXCEEDS_MAX_TOPUP_AMOUNT]: 'Debit Card Payment Request Exceeds Max Topup Amount',
	[TRANSACTION_REJECTED]: 'Transaction Rejected',
};

export const CURRENCY = {
	OMR: 'OMR',
};

export const ACC_TYPE = { MOBILE: 'MOBILE' };
